export const copyToClipBoard = (content: string) => {
    navigator.clipboard.writeText(content);
};